"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LogMessages = exports.MessageDescription = exports.MessageHttpStatusCode = exports.MessageCategory = exports.MessageMetaData = exports.MessageAnonymous = exports.ErrorMessage = exports.EventMessage = void 0;
const shim_logger_messages_1 = require("./shim-logger.messages");
function EventMessage(messageString, audience) {
    return (target, name) => {
        return shim_logger_messages_1.LogMessagesManager.setDescriptor(messageString, target, name, audience);
    };
}
exports.EventMessage = EventMessage;
function ErrorMessage(messageString, audience) {
    return (target, name) => {
        return shim_logger_messages_1.LogMessagesManager.setDescriptor(messageString, target, name, audience);
    };
}
exports.ErrorMessage = ErrorMessage;
function MessageAnonymous() {
    return (target, name) => {
        shim_logger_messages_1.LogMessagesManager.setAnonymous(name);
        return Object.getOwnPropertyDescriptor(target, name);
    };
}
exports.MessageAnonymous = MessageAnonymous;
function MessageMetaData(meta) {
    return (target, name) => {
        shim_logger_messages_1.LogMessagesManager.setMeta(name, meta);
        return Object.getOwnPropertyDescriptor(target, name);
    };
}
exports.MessageMetaData = MessageMetaData;
function MessageCategory(category) {
    return (target, name) => {
        shim_logger_messages_1.LogMessagesManager.setMeta(name, { category: category });
        return Object.getOwnPropertyDescriptor(target, name);
    };
}
exports.MessageCategory = MessageCategory;
function MessageHttpStatusCode(statusCode) {
    return (target, name) => {
        shim_logger_messages_1.LogMessagesManager.setHttpStatusCode(name, statusCode);
        return Object.getOwnPropertyDescriptor(target, name);
    };
}
exports.MessageHttpStatusCode = MessageHttpStatusCode;
function MessageDescription(text) {
    return (target, name) => {
        shim_logger_messages_1.LogMessagesManager.setDescription(name, text);
        return Object.getOwnPropertyDescriptor(target, name);
    };
}
exports.MessageDescription = MessageDescription;
function LogMessages(constructor) {
    return class extends constructor {
    };
}
exports.LogMessages = LogMessages;
